import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Injector } from '@angular/core';
import { AlertService, AlertMessage } from '@dekra/alert-service-lib';
import { LoginService } from 'src/app/shared/login/login.service';
import { catchError } from 'rxjs/operators';
import { PrincipalService } from '../security/authentication/principal.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /* Mensajes de error */
  EXPIRED_SESSION_MSG: string;
  UNAUTHORIZED_MSG: string;
  ERROR_MSG: string;
  INTERCEPTOR_SKIP_HEADER: string;

  constructor(private injector: Injector, private router: Router, private alert: AlertService, private principalServices:PrincipalService) {
    this.EXPIRED_SESSION_MSG = 'Permiso denegado. Sesión expirada.';
    this.UNAUTHORIZED_MSG =
      'Permiso denegado. El usuario no tiene permisos para acceder al recurso solicitado.';
    this.ERROR_MSG = 'Ha ocurrido un error';
    this.INTERCEPTOR_SKIP_HEADER = 'X-Skip-Interceptor';
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /* Ignora el error si contiene la cabecera indicada */
    if (req.headers.has(this.INTERCEPTOR_SKIP_HEADER)) {
      const headers = req.headers.delete(this.INTERCEPTOR_SKIP_HEADER);
      return next.handle(req.clone({ headers }));
    }

    return next.handle(req).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          const customErrorMessage = err.error;
          if (err.status === 401) {
            this.alert.error(new AlertMessage({ text: this.EXPIRED_SESSION_MSG }));
            setTimeout(() => {
              const loginService: LoginService = this.injector.get(LoginService);
              //console.log('error.interceptor - logout ' + this.principalServices.getUser().username);
              console.log(err);
              loginService.logout(this.principalServices.getUser().username);
              if (sessionStorage.getItem('ssoToken')) {
                this.router.navigate(['/sso'], {
                  queryParams: { token: sessionStorage.getItem('ssoToken') }
                });
              } else {
                this.router.navigate(['/login']);
              }
            }, 500);
          } else if (err.status === 403) {
            this.alert.error(
              new AlertMessage({
                text: this.UNAUTHORIZED_MSG
              })
            );
          } else {
            this.alert.error(
              new AlertMessage({
                text: `${this.ERROR_MSG}: ${customErrorMessage.descripcion || 'desconocido'}`
              })
            );
            if (sessionStorage.getItem('ssoToken')) {
              this.router.navigate(['/sso'], {
                queryParams: { token: sessionStorage.getItem('ssoToken') }
              });
            } else {
              this.router.navigate(['/login']);
            }
          }
        }

        // Devolvemos el error
        return throwError(err);
      })
    );
  }
}
